// extracted by mini-css-extract-plugin
var _1 = "pfx-EditUserPassword-module__actions--_T2nE";
var _2 = "#000";
var _3 = "pfx-EditUserPassword-module__body--jNCjY";
var _4 = "1260px";
var _5 = "1020px";
var _6 = "668px";
var _7 = "1550px";
var _8 = "pfx-EditUserPassword-module__container--br3yj";
var _9 = "1140px";
var _a = "940px";
var _b = "100%";
var _c = "15px";
var _d = "620px";
var _e = "#f53535";
var _f = "rgba(0,0,0,.2)";
var _10 = "rgba(255,255,255,.38)";
var _11 = ".38";
var _12 = "pfx-EditUserPassword-module__error--AF6xI";
var _13 = "rgba(255,255,255,.2)";
var _14 = "#0025ff";
var _15 = "#f60";
var _16 = "#41ead4";
var _17 = "#2cdd78";
var _18 = "#66ab23";
var _19 = "#f5f5f5";
var _1a = "#c3c3c3";
var _1b = "#ececec";
var _1c = "#252525";
var _1d = "#272727";
var _1e = "#c6c6c5";
var _1f = "#333";
var _20 = "#3c3c3c";
var _21 = "#9c9b9b";
var _22 = "#8c8c8c";
var _23 = "#6f6f6e";
var _24 = "#3c3c3b";
var _25 = "#373737";
var _26 = "#6a6a69";
var _27 = "#6f6f6f";
var _28 = "#9f9e9e";
var _29 = "#282828";
var _2a = "#828181";
var _2b = "#1d1d1d";
var _2c = "#979797";
var _2d = "#9c9b9b";
var _2e = "#a7a7a6";
var _2f = "#c6c6c5";
var _30 = "#d8d8d7";
var _31 = "#dddddc";
var _32 = "pfx-EditUserPassword-module__header--HHYqf";
var _33 = "72px";
var _34 = "40px";
var _35 = "36px";
var _36 = "25px";
var _37 = "18px";
var _38 = "13px";
var _39 = "pfx-EditUserPassword-module__header-title--aH3eQ";
var _3a = "pfx-EditUserPassword-module__hide-error--nwgjn";
var _3b = "pfx-EditUserPassword-module__inner-container--PWq1y";
var _3c = "#0025ff";
var _3d = "rgba(255,255,255,.12)";
var _3e = "#6535f5";
var _3f = "2px";
var _40 = "56px";
var _41 = "56px";
var _42 = "#41ead4";
var _43 = "#f60";
var _44 = "#f83600";
var _45 = "#881f00";
var _46 = "18px";
var _47 = "15px";
var _48 = "red";
var _49 = "13px";
var _4a = "rgba(255,255,255,.07)";
var _4b = "pfx-EditUserPassword-module__success--x8wy1";
var _4c = "#35465c";
var _4d = "#55acee";
var _4e = "#fff";
var _4f = "#ffce36";
var _50 = "#ffcd00";
var _51 = "red";
export { _1 as "actions", _2 as "black", _3 as "body", _4 as "breakLarge", _5 as "breakMedium", _6 as "breakSmall", _7 as "breakVLarge", _8 as "container", _9 as "containerLarge", _a as "containerMedium", _b as "containerMobile", _c as "containerPaddingMobile", _d as "containerSmall", _e as "danger", _f as "darkElement", _10 as "disabled", _11 as "disabledOpacity", _12 as "error", _13 as "extraLightElement", _14 as "facebook", _15 as "google", _16 as "green", _17 as "green2", _18 as "greenColor", _19 as "grey1", _1a as "grey10", _1b as "grey2", _1c as "grey25", _1d as "grey27", _1e as "grey3", _1f as "grey33", _20 as "grey3C", _21 as "grey4", _22 as "grey41", _23 as "grey5", _24 as "grey6", _25 as "grey61", _26 as "grey6A", _27 as "grey6F", _28 as "grey7", _29 as "grey8", _2a as "grey82", _2b as "grey9", _2c as "grey97", _2d as "grey9C", _2e as "greyA7", _2f as "greyC6", _30 as "greyD8", _31 as "greyDd", _32 as "header", _33 as "header1", _34 as "header2", _35 as "header3", _36 as "header4", _37 as "header5", _38 as "header6", _39 as "headerTitle", _3a as "hideError", _3b as "innerContainer", _3c as "klein", _3d as "lightElement", _3e as "lilac", _3f as "menuBorder", _40 as "menuHeight", _41 as "menuMobileHeight", _42 as "ocean", _43 as "orange", _44 as "orange2", _45 as "orangeDark", _46 as "paragraph", _47 as "paragraphSmall", _48 as "red", _49 as "subHeaderSmall", _4a as "subtleLightElement", _4b as "success", _4c as "tumblr", _4d as "twitter", _4e as "white", _4f as "yellow", _50 as "yellowDeep", _51 as "youtube" }
